import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const index = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/index.vue");
const guideQa = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-qa.vue");
const guideMaterial = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-material.vue");
const guideNote = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-note.vue");
const guideForm = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-form.vue");
const policyDetail = () =>
  import(/* webpackChunkName: "guide" */ "./src/components/policy_detail.vue");
const kslbguide = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/kslbguide.vue");
const easydo = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/easydo/index.vue");
const fastdo = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/fastdo/index.vue");
console.log(REGION);
export default new Router({
  base: `/qykj/${PROJECTNAME}`,
  mode: "history",
  fallback: false,
  routes: [
    {
      path: "/guide",
      component: index,
      children: [
        {
          path: "qa",
          component: guideQa
        },
        {
          path: "material",
          component: guideMaterial
        },
        {
          path: "note",
          component: guideNote
        },
        {
          path: "form",
          component: guideForm
        }
      ]
    },
    {
      path: "/kslbguide",
      name: "kslbguide",
      component: kslbguide
    },
    {
      path: "/policydetail",
      name: "policydetail",
      component: policyDetail
    },
    {
      name: "easydo",
      path: "/easydo",
      component: easydo
    },
    {
      name: "fastdo",
      path: "/fastdo",
      component: fastdo
    }
  ]
});



// WEBPACK FOOTER //
// ./yp/router.js